module.exports = __webpack_public_path__ + "img/avterracebox21.761fff12.jpg";